// portalRouting — decides which portal a signed-in user can actually enter
// Resolves from the real profile row rather than user_metadata, because every
// portal query is RLS-scoped through students/counselors.auth_user_id.
//
// The marketplace is intentionally disconnected from all navigation: its code
// remains in the repo but nothing routes to it. Users without a profile row
// therefore fall back to the student workspace rather than the marketplace.

import { supabase } from '../lib/supabase'

export type PortalPath = '/student' | '/counselor'

export async function resolvePortalPath(authUserId: string): Promise<PortalPath> {
  try {
    // maybeSingle (not single) so "no row" resolves to null instead of throwing
    const [student, counselor] = await Promise.all([
      supabase.from('students').select('id').eq('auth_user_id', authUserId).maybeSingle(),
      supabase.from('counselors').select('id').eq('auth_user_id', authUserId).maybeSingle(),
    ])

    if (counselor.data?.id) return '/counselor'
    if (student.data?.id) return '/student'
  } catch {
    // Network/RLS failure — fall through to the default workspace
  }

  // Default workspace. Was '/marketplace'; changed so no path can reach it.
  return '/student'
}
